'use client';

import {
  Button,
  Typography,
  TypographyMods,
  TypographySizes,
} from '@vk-cloud-solutions/marketing-ui';

import { Image } from '~components/Image/Image';
import { LayoutContainer } from '~components/LayoutContainer/LayoutContainer';
import { ErrorPageProps } from '~containers/ErrorPage/ErrorPage.types';

import styles from './ErrorPage.module.scss';

// TODO заменить на Hero из mark-ui

export const ErrorPage = ({ title, text, image, button }: ErrorPageProps) => {
  return (
    <LayoutContainer className={styles.container}>
      <div className={styles.content}>
        <Typography
          tagName={TypographySizes.h1}
          mods={[TypographyMods.displayM]}
        >
          {title}
        </Typography>
        <Typography className={styles.text} mods={[TypographyMods.bodyL]}>
          {text}
        </Typography>
        <div className={styles.buttonWrapper}>
          <Button {...button} />
        </div>
      </div>
      <div className={styles.imageContainer}>
        <Image {...image} />
      </div>
    </LayoutContainer>
  );
};
